import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label} from "reactstrap"
import {filterProcedure} from "../../helpers/skuFilter"

class FilterProcedure extends Component {
    _handleChangeStatus = (e) => {
        const {name, value} = e.target
        const {onChangeFilter} = this.props

        if (typeof onChangeFilter === 'function') {
            onChangeFilter(name, value)
        }
    }

    render() {
        const {procedure} = this.props

        return (
            <div className="FilterProcedure">
                <FormGroup>
                    <Label className='font-weight-bold'>Quy trình </Label>
                    <Input type='select' value={procedure} name='procedure' onChange={this._handleChangeStatus}>
                        {
                            filterProcedure.map(item => {
                                return <option key={item.value} value={item.value}>{item.name}</option>
                            })
                        }
                    </Input>
                </FormGroup>
            </div>
        )
    }
}

FilterProcedure.propTypes = {
    procedure: PropTypes.any,
    onChangeFilter: PropTypes.func
}

export default FilterProcedure